var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmexLogoBorderTransavia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "27px",
    viewBox: "0 0 41 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "amex_logo_border_transavia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transavia",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "amex_logo_border_transavia",
    transform: "translate(0.500000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,26 L38,26 C39.1045695,26 40,25.1045695 40,24 L40,2 C40,0.8954305 39.1045695,-2.02906125e-16 38,0 L2,0 C0.8954305,2.02906125e-16 -1.3527075e-16,0.8954305 0,2 L0,24 C1.3527075e-16,25.1045695 0.8954305,26 2,26 Z",
    id: "Path",
    stroke: "#BCBCBC",
    fill: "#016FD0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.69,13.63 L30.69,15.27 L26.52,15.27 L26.52,16.41 L30.59,16.41 L30.59,18.05 L26.52,18.05 L26.52,19.17 L30.69,19.17 L30.69,20.83 L34.07,17.23 L30.69,13.63 L30.69,13.63 Z M29.59,7.49 L28.19,4.3 L24.19,4.3 L20.09,13.62 L23.42,13.62 L23.42,21.89 L33.7,21.9 L35.31,20.1 L36.94,21.9 L40,21.9 L40,19.27 L38.08,17.21 L40,15.16 L40,12.57 L38.07,12.58 L38.07,7.6 L36.26,12.58 L34.5,12.58 L32.64,7.58 L32.64,12.58 L28.44,12.58 L27.84,11.12 L24.54,11.12 L23.94,12.58 L21.72,12.58 L24.95,5.31 L24.95,5.3 L27.5,5.3 L30.69,12.51 L30.69,5.3 L33.79,5.31 L35.39,9.78 L37.01,5.3 L40,5.3 L40,4.3 L36.23,4.3 L35.38,6.69 L34.53,4.3 L29.59,4.3 L29.59,7.49 L29.59,7.49 Z M24.53,13.6 L24.53,20.87 L30.69,20.87 L30.69,20.86 L33.23,20.86 L35.33,18.54 L37.45,20.86 L40,20.86 L40,20.76 L36.66,17.23 L40,13.65 L40,13.6 L37.48,13.6 L35.38,15.9 L33.3,13.6 L24.53,13.6 L24.53,13.6 Z M25.23,9.49 L26.19,7.18 L27.16,9.49 L25.23,9.49 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexLogoBorderTransavia);
export default __webpack_public_path__ + "static/media/amex_logo_border_transavia.b78786dda21b7f133f8310fff5f83af2.svg";
export { ForwardRef as ReactComponent };